$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay,} from 'swiper/modules';

import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';




gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav-active ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


     /*-------- Swiper BLUEPROTECT ---------*/
     var swiper = new Swiper(".swiper__blueprotect", {
        modules: [Navigation, Autoplay, Pagination],
        autoplay: {
            delay: 5000,
          },
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
      });

       /*-------- Swiper BOGE ---------*/
     var swiper = new Swiper(".swiper__boge", {
        modules: [Navigation, Autoplay, Pagination],
        autoplay: {
            delay: 5000,
          },
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
      });


      
    
    

     /*-------- Swiper Article ---------*/



      var swiperArticle = new Swiper(".swiper__article", {
        modules: [Navigation, Autoplay, Pagination],
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        },
        breakpoints: {
            576: {
                slidesPerView: 4,
                spaceBetween: 10
            },
            
            1200: {
                slidesPerView: 4,
                spaceBetween: 10
            }
        }

      });

    
      var prev = $('.col__navigation .swiper-navigation .swiper-prev');
      var next = $('.col__navigation .swiper-navigation .swiper-next');
      
      console.log(swiperArticle.slides.length);

      if (swiperArticle.slides.length > 4) {
          
        prev.css('visibility', 'visible');
        next.css('visibility', 'visible');
          
      } 
    

     



    /*-------- MASONRY ---------*/
    
    const grid = document.querySelector('.masonry');
    imagesLoaded(grid, function() {
        const msnry = new Masonry(grid, {
            itemSelector: '.masonry-item',
            columnWidth: '.masonry-sizer',
        percentPosition: true,
        horizontalOrder: true
        });
    });

   
    
});

    
    

